import { hostname, projectHosts } from '../../config'
let baseUrl;
//`development` 开发版本 `production`  生产版本
if (process.env.NODE_ENV === `development`) {
  baseUrl = `http://${projectHosts.admin}.${hostname}/portal`;//服务器地址前缀
  // baseUrl = `http://192.168.0.113:8100`

} else {
  baseUrl = `http://${projectHosts.admin}.${hostname}/portal`;//服务器地址前缀

}

//baseUrl = `http://192.168.40.78:8100`
baseUrl = 'https://qy.nxtt.org.cn/portal2'


export default baseUrl;


// export const qxtUrl = process.env.NODE_ENV === `development`? `http://${projectHosts.qxt}.${hostname}/portal`:`http://${projectHosts.qxt}.${hostname}/portal`
// export const patentUrl = process.env.NODE_ENV === `development`? `http://${projectHosts.service}.${hostname}/portal`:`http://${projectHosts.service}.${hostname}/portal`
// export const examUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.service}.${hostname}/portal`:`http://${projectHosts.service}.${hostname}/portal`
// export const policyUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.shenbao}.${hostname}/portal`:`http://${projectHosts.shenbao}.${hostname}/portal`
// export const imgUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.admin}.${hostname}/portal`:`http://${projectHosts.admin}.${hostname}/portal`
// export const certificationUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.qxt}.${hostname}/portal`:`http://${projectHosts.qxt}.${hostname}/portal`
// export const indexUrl = process.env.NODE_ENV === `development` ? `http://${projectHosts.cms}.${hostname}`: `http://${projectHosts.cms}.${hostname}`
// export const storebaseUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.data}.${hostname}`:`http://${projectHosts.data}.${hostname}`
// export const resourceUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.data}.${hostname}`:`http://${projectHosts.data}.${hostname}`
// export const nianfeiUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.service}.${hostname}/portal`:`http://${projectHosts.service}.${hostname}/portal`


export const qxtUrl = 'http://192.168.20.192:5100'
export const patentUrl = 'https://qy.nxtt.org.cn/portal'
export const examUrl = 'https://qy.nxtt.org.cn/portal'
export const nianfeiUrl = 'https://qy.nxtt.org.cn/portal'
// export const patentUrl = 'http://192.168.40.78:6100'
// export const examUrl = 'http://192.168.40.78:6100'
// export const nianfeiUrl = 'http://192.168.40.78:6100'
export const policyUrl = process.env.NODE_ENV === `development`?`http://${projectHosts.shenbao}.${hostname}/portal`:`http://${projectHosts.shenbao}.${hostname}/portal`
export const imgUrl = 'http://192.168.20.192:6200'
export const certificationUrl = 'http://192.168.20.192:5100'
export const indexUrl = 'http://192.168.40.78:8002'
export const storebaseUrl = 'http://192.168.20.192:4100'
export const resourceUrl = 'http://192.168.20.192:4100'


// 第三方万方地址
export const wfUrl = "https://webstads.sciinfo.cn"
